import React from 'react';
import { Link } from 'react-router-dom';

const Sidebar = (props) => {
    const path = props.history.location.pathname;

    let permissions = [];
    if (props.user && props.user.uth_permissions != null) {
        permissions = JSON.parse(props.user.uth_permissions);
    }

    const getCategoriesClasses = () => {
        if (path === '/orders/pending' || path === '/orders/approved' || path === '/orders/rejected' || path === '/shopping-cart' ||
            path === '/admin/forms' || path === '/admin/promotional-items' || path === '/admin/apparel-items' ||
            path.includes('/apparel-item-parts') || path === '/my-favorites' || path === '/admin/help-desk') {
            return 'menu-item';
        }
        return 'menu-item active';
    }

    let categoriesUrl = '/';
    if (props.platformType === 'utp') {
        categoriesUrl = '/utp';
    } else if (props.platformType === 'uth') {
        categoriesUrl = '/uth';
    }

    const handleSwitch = () => {
        props.clearPlatformType();
        props.history.push('/');
    };

    let adminApparelItems = null;
    let adminForms = null;
    let adminPromotionalItems = null;
    let adminReports = null;
    let adminHelpDesk = null;
    let adminDepartments = null;
    let adminSizeCharts = null;
    let adminUsers = null;

    let openTickets = null;
    if (props.openTickets !== '' && props.openTickets > 0) {
        openTickets = <div className="help-desk-items">{props.openTickets}</div>;
    }

    if (permissions.includes('apparel')) {
        adminApparelItems = (
            <Link to="/admin/apparel-items">
                <div className={'menu-item' + (path === '/admin/apparel-items' || path.includes('/apparel-item-parts') ? ' active' : '')}>
                    <i className="fas fa-tshirt" /> Apparel Items
                </div>
            </Link>
        );
    }

    if (permissions.includes('forms')) {
        adminForms = (
            <Link to="/admin/forms">
                <div className={'menu-item' + (path === '/admin/forms' ? ' active' : '')}>
                    <i className="fas fa-file-alt" /> Forms
                </div>
            </Link>
        );
    }

    if (permissions.includes('promotional')) {
        adminPromotionalItems = (
            <Link to="/admin/promotional-items">
                <div className={'menu-item' + (path === '/admin/promotional-items' ? ' active' : '')}>
                    <i className="fas fa-marker" /> Promotional Items
                </div>
            </Link>
        );
    }

    if (permissions.includes('reports')) {
        adminReports = (
            <Link to="/admin/reports">
                <div className={'menu-item' + (path === '/admin/reports' ? ' active' : '')}>
                    <i className="fas fa-database" /> Reports
                </div>
            </Link>
        );
    }

    if (permissions.includes('help-desk')) {
        adminHelpDesk = (
            <Link to="/admin/help-desk">
                <div className={'menu-item' + (path === '/admin/help-desk' ? ' active' : '')}>
                    <i className="fas fa-address-card" /> Help Desk {openTickets}
                </div>
            </Link>
        );
    }

    if (permissions.includes('departments')) {
        adminDepartments = (
            <Link to="/admin/departments">
                <div className={'menu-item' + (path === '/admin/departments' ? ' active' : '')}>
                    <i className="fas fa-database" /> Departments
                </div>
            </Link>
        );
    }

    if (permissions.includes('size-charts')) {
        adminSizeCharts = (
            <Link to="/admin/size-charts">
                <div className={'menu-item' + (path === '/admin/size-charts' ? ' active' : '')}>
                    <i className="fas fa-table" /> Size Charts
                </div>
            </Link>
        );
    }

    if (permissions.includes('users')) {
        adminUsers = (
            <Link to="/admin/users">
                <div className={'menu-item' + (path === '/admin/users' ? ' active' : '')}>
                    <i className="fas fa-users" /> Users
                </div>
            </Link>
        );
    }

    let adminTitle = null;
    if (
        adminApparelItems != null ||
        adminForms != null ||
        adminPromotionalItems != null ||
        adminReports != null ||
        adminHelpDesk != null ||
        adminDepartments != null ||
        adminSizeCharts != null ||
        adminUsers != null
    ) {
        adminTitle = <h3>Admin</h3>;
    }

    let organizationName = null;
    if (props.platformType === 'utp') {
        organizationName = 'UT Physicians';
    } else if (props.platformType === 'uth') {
        organizationName = 'UTHealth Houston';
    }

    if (props.cxmlData.buyer_cookie != null && ['pamela.h.butler@uth.tmc.edu', 'nicole.l.brown@uth.tmc.edu',
        'robina.a.philipose@uth.tmc.edu'].includes(props.cxmlData.email.toLowerCase())) {
        organizationName = 'Treasury';
    }

    return (
        <div className="sidebar-container">
            <div className="top-container">
                <div className="logo">{organizationName}</div>
                <div className="menu">
                    <Link to={categoriesUrl}>
                        <div className={getCategoriesClasses()}>
                            <i className="fas fa-id-card" /> Categories
                        </div>
                    </Link>
                    <Link to="/my-favorites">
                        <div className={'menu-item' + (path === '/my-favorites' ? ' active' : '')}>
                            <i className="fas fa-heart" /> My Favorites
                        </div>
                    </Link>
                    <Link to="/shopping-cart">
                        <div className={'menu-item' + (path === '/shopping-cart' ? ' active' : '')}>
                            <i className="fas fa-shopping-cart" /> Shopping Cart
                        </div>
                    </Link>
                    <Link to="/orders/pending">
                        <div className={'menu-item' + (path === '/orders/pending' ? ' active' : '')}>
                            <i className="fas fa-clock" /> Pending Orders
                        </div>
                    </Link>
                    <Link to="/orders/approved">
                        <div className={'menu-item' + (path === '/orders/approved' ? ' active' : '')}>
                            <i className="fas fa-check-circle" /> Approved Orders
                        </div>
                    </Link>
                    <Link to="/orders/rejected">
                        <div className={'menu-item' + (path === '/orders/rejected' ? ' active' : '')}>
                            <i className="fas fa-times-circle" /> Rejected Orders
                        </div>
                    </Link>
                    {adminTitle}
                    {adminHelpDesk}
                    {adminDepartments}
                    {adminApparelItems}
                    {adminForms}
                    {adminPromotionalItems}
                    {adminSizeCharts}
                    {adminReports}
                    {adminUsers}
                </div>
            </div>
            <div className="bottom-container">
                <div className="switch" onClick={handleSwitch}><i className="fas fa-exchange-alt" /> Switch Organization</div>
            </div>
        </div>
    );
}

export default Sidebar;
